export const translations = {
    en: {
        nav: {
            home: 'HOME',
            game: 'GAME',
            swap: 'SWAP',
            rewards: 'REWARDS',
            connect: 'CONNECT WALLET',
            connected: 'CONNECTED',
            system_online: 'SYSTEM ONLINE',
            title: 'BNB ANNIHILATION'
        },
        home: {
            hero_title: 'BNB ANNIHILATION PROTOCOL',
            hero_edition: 'Event Horizon Access',
            hero_desc: 'Value Through Vaporization. Built on BNB Chain: We don\'t produce assets, we distill scarcity. A hyper-deflationary engine powered by smart contracts—every interaction is a dimensional strike against the inflationary universe.',
            connecting: 'CONNECTING...',
            start_playing: 'ENTER THE EVENT HORIZON',
            learn_more: 'READ THE MANIFESTO',
            ticker: {
                status: 'SYSTEM STATUS: ONLINE // INTEGRITY 100%',
                network: 'NETWORK: BSC MAINNET // LATENCY: 12ms',
                security: 'SECURITY: AUDIT PASSED // CONTRACT VERIFIED',
                phase: 'PROTOCOL PHASE: ACCUMULATION // ACTIVE',
                next_burn: 'CRITICAL ALERT: Singularity threshold approaching... | Next collapse: T-Minus 00:05:00'
            },
            telemetry: {
                title: 'Black Hole Telemetry',
                burn: 'Annihilation Feed',
                nodes: 'Active Relays',
                entropy: 'Entropy Pulse',
                awaiting: 'SYNCING',
                live: 'LIVE',
                hint_burn: 'Awaiting on-chain oracle · no spoofed totals',
                hint_nodes: 'Player relays & validator bridges coming online',
                hint_entropy: 'Protocol heat signature · code pulse only'
            },
            preface: {
                title: 'The Art of Negentropy',
                p1: 'The ultimate fate of the universe is heat death, where all things tend towards disorder. But in the digital universe of BNB Chain, we are building a reverse singularity.',
                p2: 'BNB Annihilation Protocol (B.A.P) is not a traditional GameFi platform; it is a massive decentralized black hole. In the existing crypto economy, inflation is the original sin of asset depreciation; in the world of B.A.P, we sublimate “burning” into an art form.',
                p3: 'We invite you to enter the Event Horizon. Here, every game is a sacrifice towards death and rebirth, every interaction irreversibly reduces the total token supply. We do not create inflation; we manufacture scarcity. Join this magnificent annihilation, not just for entertainment, but to capture the eternity of value.'
            },
            philosophy: {
                title: 'Core Philosophy: The Black Hole Mechanism',
                p1_title: 'The “Heat Death” Dilemma of Traditional GameFi',
                p1_desc: 'Traditional P2E models invariably fall into the death spiral of “mine-sell-withdraw”. Infinitely minted tokens are like an expanding universe, ultimately leading to value dilution and ecosystem collapse.',
                p2_title: 'The Annihilation Solution',
                p2_desc: 'B.A.P introduces the consensus mechanism of “Interaction as Annihilation”. Our DApp is a black hole with immense gravity, and all connected games are its Accretion Disk.',
                f1_title: 'Absolute Deflation',
                f1_desc: 'No inflation mechanism. The total token supply peaks at genesis and only decreases thereafter, never increasing.',
                f2_title: 'Game as Fuel',
                f2_desc: 'Every game on the platform is designed to accelerate token burning. Player consumption, losses, or fees are sent directly to the black hole address (0x00...dead).'
            },
            thermodynamics: {
                title: 'Financial Thermodynamics',
                subtitle: 'The Physics of Value',
                anti_entropy: {
                    title: 'Anti-Entropy',
                    desc: 'In the expanding crypto universe, "inflation" is the culprit of value heat death. B.A.P is a massive Negentropy Machine—through continuous burning, we convert chaotic tokens into ordered value.'
                },
                event_horizon: {
                    title: 'Event Horizon',
                    desc: 'We built a one-way membrane—the Event Horizon. Once tokens cross this boundary (enter games), they cannot escape. Only two outcomes exist: become the winner\'s spoils (aggregation) or the black hole\'s fuel (annihilation). No third path.'
                }
            },
            binary_system: {
                title: 'Binary Star System',
                subtitle: 'Dual-Token Mechanics',
                fuel_token: {
                    title: 'Fuel Token - The Matter',
                    desc: 'Consumable matter. The ticket to enter higher-dimensional games. Their sole purpose is to burn. Each round irreversibly reduces the cosmic total supply until zero.'
                },
                bnb_token: {
                    title: 'BNB - The Energy',
                    desc: 'Dark energy. The universal pricing unit and reward carrier. It doesn\'t vanish in games but flows at high frequency between winners and protocol treasury, like Hawking Radiation feeding survivors.'
                },
                loop: {
                    title: 'The Protocol Loop',
                    steps: ['Injection', 'Reaction', 'Annihilation', 'Radiation']
                }
            },
            roadmap: {
                title: 'Cosmic Evolution',
                subtitle: 'Protocol Roadmap',
                phase1: {
                    name: 'Phase I: Nebula',
                    desc: 'Protocol launch. Gravity core formation. First batch of fuel tokens injected. Event Horizon takes shape.'
                },
                phase2: {
                    name: 'Phase II: Protostar',
                    desc: 'Game matrix integration. High-frequency interactions trigger fusion reactions. Burn rate rises exponentially.'
                },
                phase3: {
                    name: 'Phase III: Supernova',
                    desc: 'Token supply breaks critical threshold. Scarcity triggers value explosion. Ecosystem gravity captures network liquidity.'
                },
                phase4: {
                    name: 'Phase IV: Black Hole',
                    desc: 'Ultimate deflation. Eternal operation. Self-sustaining Event Horizon formed, devouring all inflationary bubbles.'
                }
            },
            ecosystem: {
                title: 'The Ecosystem: Event Horizon DApp',
                desc: 'Our DApp aggregation platform is called “Event Horizon”. This is the boundary around a black hole; once crossed, no matter (token) can escape.',
                matrix_title: 'Annihilation Game Matrix',
                matrix_desc: 'We don’t just aggregate games; we aggregate “burning scenarios”.',
                roulette: {
                    title: 'Entropy Roulette',
                    desc: 'Minimalist high-frequency gaming. Loser’s tokens are swallowed by the black hole; winners earn rewards. Burn Rate: 100% of lost funds.'
                },
                survivor: {
                    title: 'The Last Survivor',
                    desc: 'Battle Royale mode. Half of the entry fee is burned directly, the other half goes to the prize pool.'
                },
                raid: {
                    title: 'Interstellar Raid',
                    desc: 'Strategy game. Upgrading ships and buying fuel consumes tokens, permanently removing them from circulation.'
                }
            },
            games: {
                title: 'Games Matrix',
                subtitle: 'Every title is engineered as an accelerant to burn',
                guess: {
                    status: 'LIVE',
                    title: 'Quantum Guess',
                    desc: 'Probability collapse engine. Navigate quantum fog between 0 and 1 seeking certainty. Each wrong observation vaporizes funds instantly. Can you see Schrödinger\'s cat?',
                    btn: 'Enter Game'
                },
                dice: {
                    title: 'Entropy Roulette',
                    desc: 'High-frequency risk oscillator. Russian roulette with smart contracts. Minimalist rules, extreme violent aesthetics—losers vaporize instantly, winners take all.',
                    status: 'INTEGRATING'
                },
                crash: {
                    title: 'The Last Survivor',
                    desc: 'Battle Royale entry fees split between burn and prize pool.',
                    status: 'DESIGN'
                },
                lottery: {
                    title: 'Dark Forest Raid',
                    desc: 'Zero-sum battlefield. In this resource-scarce universe, hide yourself and prepare to cleanse. Use fuel to upgrade coordinates, launch dimensional strikes on opponents, plunder their liquidity.',
                    status: 'DESIGN'
                }
            },
            features: {
                title: 'Protocol Tenets',
                fair: {
                    title: 'Audited & Verifiable',
                    desc: 'Transparent contracts with verifiable burn addresses and audit trails.'
                },
                burn: {
                    title: 'Burn-First Economics',
                    desc: 'No inflationary levers. Every interaction routes value toward the void.'
                },
                instant: {
                    title: 'Instant Settlements',
                    desc: 'Fast finality on BNB Chain with low-latency interaction feedback.'
                },
                community: {
                    title: 'Community Gravity',
                    desc: 'Builders plug into the Event Horizon; incentives align with scarcity.'
                }
            },
            faq: {
                title: 'FAQ · Event Horizon',
                q1: 'How do you ensure the burn numbers are real?',
                a1: 'On-chain proof only. We display live telemetry when oracle feeds are connected and avoid fabricated placeholder totals.',
                q2: 'Why build on BNB Chain?',
                a2: 'Low fees and deep liquidity make rapid burn interactions viable without eroding player experience.',
                q3: 'How do games join the matrix?',
                a3: 'Studios integrate via the Event Horizon SDK and agree to interaction-as-annihilation economics.',
                q4: 'Why is Code Law?',
                a4: 'At B.A.P, we trust math, not humanity. Contract ownership is renounced. Liquidity is locked. The black hole has no backdoor. Mathematics has no bias.',
                q5: 'How do you define "fairness"?',
                a5: 'Absolute randomness via on-chain VRF (Verifiable Random Function). God doesn\'t play dice, but our smart contracts do. Every outcome is traceable, verifiable, and immutable.'
            },
            cta: {
                title: 'Cross the Event Horizon',
                desc: 'No inflation. No mercy. Just the art of annihilation.',
                btn: 'CONNECT INTERFACE'
            },
            entropy: {
                section_title: 'THE ART OF NEGENTROPY',
                module1: {
                    tag: 'ENTROPY_PROBLEM',
                    title: 'Cosmic Heat Death',
                    content: 'The universe tends toward maximum entropy—disorder, chaos, heat death. In traditional crypto economies, inflation is the original sin. Unlimited token minting dilutes value like an expanding universe cooling toward absolute zero.\n\nEvery new token is a step closer to economic heat death. The end state is inevitable: worthless assets scattered across a cold, dead blockchain.',
                    keywords: ['heat death', 'inflation', 'entropy', 'dilutes value']
                },
                module2: {
                    tag: 'BLACK_HOLE_SOLUTION',
                    title: 'B.A.P. Mechanism',
                    content: 'BNB Annihilation Protocol is a reverse singularity—a black hole that devours tokens irreversibly. Every game interaction triggers permanent burning. Tokens cross the event horizon and vanish into address 0x00...dead.\n\nThis is not deflation. This is annihilation. We don\'t reduce supply—we erase it from existence. The protocol is a one-way membrane: enter, burn, never return.',
                    keywords: ['black hole', 'irreversibly', 'annihilation', 'event horizon', 'one-way']
                },
                module3: {
                    tag: 'VALUE_SINGULARITY',
                    title: 'Scarcity Capture',
                    content: 'As total supply collapses toward zero, remaining tokens compress into a value singularity. Scarcity is not manufactured—it is mathematically enforced. Each burn increases the gravitational pull on remaining value.\n\nWinners don\'t just earn rewards—they capture concentrated value from a shrinking universe. This is financial alchemy: transforming abundance into scarcity, chaos into order.',
                    keywords: ['singularity', 'scarcity', 'mathematically enforced', 'concentrated value', 'alchemy']
                }
            }
        },
        game: {
            title: 'Entropy Roulette',
            subtitle: 'Multi-round · Token Burn · Fair Random',
            connect_wallet: 'Connect MetaMask',
            admin_mode: 'Admin Console',
            owner_mode: 'Owner Mode',
            game_mode: 'Game Mode',
            game_mode_desc: 'Select a round to play',
            connecting_contract: 'Connecting Smart Contract',
            setup_contract: 'Setup Contract Address',
            default_contract: 'Default Contract Configured',
            use_this: 'Use This Address',
            or_input: 'Or input other contract address...',
            set_contract_btn: 'Set Contract',
            loading: 'Processing, please wait...',
            owner_console: 'Owner Console',
            owner_desc: 'Access for contract deployer only · Create and manage rounds',
            fuel_token_addr: 'Fuel Token Address',
            quick_select: 'Quick Select:',
            burn_amount: 'Burn Amount',
            ticket_price: 'Ticket Price (BNB)',
            duration: 'Duration (Hours)',
            start_round: 'Start New Round',
            active_rounds: 'Active Rounds',
            no_active_rounds: 'No active rounds currently',
            round: 'Round',
            pot: 'Pot',
            participants: 'Players',
            time_left: 'Time Left',
            ended: 'Ended',
            join: 'Join Game',
            settle: 'Settle Round',
            my_number: 'My Number',
            max_number: 'Max Number',
            status: {
                active: 'Active',
                settled: 'Settled'
            },
            steps: {
                approve: 'Step 1/2: Approving Token...',
                join: 'Step 2/2: Joining Game...'
            },
            errors: {
                install_metamask: 'Please install MetaMask',
                connect_failed: 'Connection Failed',
                setup_failed: 'Setup Failed',
                invalid_addr: 'Invalid Address',
                already_joined: 'You have already joined this round'
            },
            success: {
                connected: 'Wallet Connected!',
                contract_set: 'Contract Connected!',
                round_started: 'New Round Started!',
                joined: 'Successfully Joined!',
                settled: 'Round Settled! Rewards Distributed'
            },
            hall: {
                title: 'Game Hall',
                desc: 'Select a round to start betting',
                total_rounds: 'Total Rounds',
                active: 'Active',
                no_games: 'No active games',
                admin_hint: 'Start a new round in admin console'
            },
            auto_connected: 'Auto-connected to contract successfully!',
            cleanup: {
                button: 'Cleanup Expired',
                processing: 'Cleaning expired rounds...',
                success_count: 'Successfully cleaned {count} expired rounds!',
                success_none: 'No expired rounds found to clean',
                error: 'Cleanup failed: {error}'
            },
            card: {
                prize_pool: 'PRIZE POOL',
                players: 'PLAYERS',
                time_left: 'TIME LEFT',
                ticket: 'TICKET',
                burn: 'BURN',
                tokens: 'TOKENS',
                enter_game: 'ENTER GAME',
                burning: 'BURNING',
                winner: 'WINNER',
                claim: 'CLAIM REWARD',
                settle: 'SETTLE ROUND',
                full: 'FULL CAPACITY',
                expired: 'EXPIRED',
                joined: 'JOINED SUCCESSFULLY',
                your_number: 'YOUR NUMBER',
                status: {
                    run: 'RUN',
                    end: 'END',
                    waiting: 'WAITING FOR SETTLEMENT',
                    active: 'STATUS'
                }
            },
            rules: {
                title: 'GAME MECHANICS',
                subtitle: 'System Blueprint & Protocol',
                dual_token: {
                    title: 'DUAL-TOKEN SYSTEM',
                    fuel: 'Fuel Token',
                    fuel_desc: '100% Burned to Black Hole',
                    settlement: 'Settlement Token',
                    settlement_desc: 'BNB for Rewards'
                },
                allocation: {
                    title: 'FUND ALLOCATION',
                    winner: 'Winner Pool',
                    reserve: 'Next Round Reserve',
                    dev: 'Development'
                },
                cycle: {
                    title: 'GAME CYCLE',
                    step1: 'Start Round',
                    step1_desc: 'Admin sets tokens & duration',
                    step2: 'Join & Flip',
                    step2_desc: 'Pay BNB + Fuel → Random Number',
                    step3: 'Settlement Trigger',
                    step3_desc: '20 Players OR Time Expires',
                    step4: 'Settle & Distribute',
                    step4_desc: 'Highest Number Wins',
                    condition_a: 'Condition A',
                    condition_b: 'Condition B',
                    or: 'OR'
                }
            }
        }
    },
    zh: {
        nav: {
            home: '首页',
            game: '游戏',
            swap: '兑换',
            rewards: '激励',
            connect: '连接钱包',
            connected: '已连接',
            system_online: '系统在线',
            title: 'BNB 湮灭协议'
        },
        home: {
            hero_title: 'BNB 湮灭协议',
            hero_edition: '事件视界通行',
            hero_desc: '价值源于湮灭。在BNB Chain构建的数字奇点：我们不生产资产，我们提炼稀缺。这是一个由智能合约驱动的超级通缩引擎，每一次交互都是对通胀宇宙的降维打击。',
            connecting: '连接中...',
            start_playing: '进入事件视界',
            learn_more: '阅读宣言',
            ticker: {
                status: '系统状态：在线 | 完整度 100%',
                network: '网络：BSC 主网 | 延迟 12ms',
                security: '安全：审计通过 | 合约已验证',
                phase: '协议阶段：积累 | 运行中',
                next_burn: 'CRITICAL ALERT: 奇点临界值接近中... | 预计下一次坍缩：T-Minus 00:05:00'
            },
            telemetry: {
                title: '黑洞遥测',
                burn: '湮灭数据流',
                nodes: '活跃中继',
                entropy: '熵脉冲',
                awaiting: '同步中',
                live: '实时',
                hint_burn: '仅显示链上数据 · 不展示伪造总量',
                hint_nodes: '玩家中继与验证节点上线中',
                hint_entropy: '协议热噪声 · 代码心跳'
            },
            preface: {
                title: '熵减的艺术',
                p1: '宇宙的终极命运是热寂，万物趋于无序。但在 BNB Chain 的数字宇宙中，我们正在构建一个逆向的奇点。',
                p2: 'BNB 湮灭协议（B.A.P）不是一个传统的 GameFi 平台，它是一个巨大的去中心化黑洞。在现有的加密经济中，通胀是资产贬值的原罪；而在 B.A.P 的世界里，我们将“销毁”升华为一种艺术。',
                p3: '我们邀请你进入事件视界（Event Horizon）。在这里，每一场游戏都是一次向死而生的献祭，每一次交互都在不可逆地减少代币总量。我们不创造通胀，我们制造稀缺。加入这场壮丽的湮灭，不仅是为了娱乐，更是为了捕获价值的永恒。'
            },
            philosophy: {
                title: '核心哲学：黑洞机制',
                p1_title: '传统 GameFi 的“热寂”困境',
                p1_desc: '传统的 P2E（Play-to-Earn）模式无一例外地陷入了“挖提卖”的死亡螺旋。无限增发的代币如同膨胀的宇宙，最终导致价值稀释，生态崩塌。',
                p2_title: '湮灭协议的解决方案',
                p2_desc: 'B.A.P 引入了“交互即销毁”（Interaction as Annihilation）的共识机制。我们的 DApp 是一个拥有巨大引力的黑洞，所有接入的游戏都是其吸积盘（Accretion Disk）。',
                f1_title: '绝对通缩',
                f1_desc: '没有通胀机制。代币总量在创世时刻即达峰值，此后只会减少，永不增加。',
                f2_title: '游戏即燃料',
                f2_desc: '平台上的每一款游戏，都是为了加速代币的燃烧而设计。玩家在游戏中的消耗、失败或手续费，将直接发送至黑洞地址（0x00...dead）。'
            },
            thermodynamics: {
                title: '金融热力学',
                subtitle: '价值的物理学',
                anti_entropy: {
                    title: '对抗热寂',
                    desc: '在加密货币的膨胀宇宙中，"增发"是导致价值热寂（Heat Death）的元凶。B.A.P 是一台巨大的"负熵机器"（Negentropy Machine），通过持续的销毁将无序的代币转化为有序的价值。'
                },
                event_horizon: {
                    title: '事件视界',
                    desc: '我们构建了一个单向膜——事件视界。代币一旦越过此界（参与游戏），便无法逃逸，只能转化为两个结果：要么成为赢家的战利品（聚合），要么成为黑洞的养料（销毁）。没有第三条路。'
                }
            },
            binary_system: {
                title: '双星系统',
                subtitle: '双代币机制',
                fuel_token: {
                    title: '燃料代币 - 物质',
                    desc: '可消耗物质。作为进入高维博弈的入场券，它们存在的唯一意义就是燃烧。每一轮游戏都在不可逆地减少其宇宙总量，直至归零。'
                },
                bnb_token: {
                    title: 'BNB - 暗能量',
                    desc: '暗能量。作为生态系统的通用计价单位与奖励载体。它不在游戏中消失，而是在赢家与协议金库之间高频流转，像霍金辐射（Hawking Radiation）一样回馈给幸存者。'
                },
                loop: {
                    title: '协议循环',
                    steps: ['注入', '反应', '湮灭', '辐射']
                }
            },
            roadmap: {
                title: '宇宙演化',
                subtitle: '协议路线图',
                phase1: {
                    name: '阶段 I：星云',
                    desc: '协议启动，引力核形成，首批燃料代币注入，事件视界初具规模。'
                },
                phase2: {
                    name: '阶段 II：原恒星',
                    desc: '游戏矩阵接入，高频交互引发核聚变反应，燃烧率指数级上升。'
                },
                phase3: {
                    name: '阶段 III：超新星',
                    desc: '代币总量跌破临界点，稀缺性引发价值爆发，生态引力捕获全网流动性。'
                },
                phase4: {
                    name: '阶段 IV：黑洞',
                    desc: '极致通缩，永恒运行。形成自我维持的事件视界，吞噬一切通胀泡沫。'
                }
            },
            ecosystem: {
                title: '生态系统：事件视界 DApp',
                desc: '我们的 DApp 聚合平台被称为“事件视界”。这是物理学中黑洞周围的边界，一旦越过，没有任何物质（代币）能够逃脱。',
                matrix_title: '湮灭游戏矩阵',
                matrix_desc: '我们不仅仅聚合游戏，我们聚合“燃烧场景”。',
                roulette: {
                    title: '熵之轮盘',
                    desc: '极简的高频博弈。输家的代币直接被黑洞吞噬，赢家获得奖励。燃烧率：100% 的失败资金。'
                },
                survivor: {
                    title: '最后幸存者',
                    desc: '大逃杀模式。入场费的一半直接销毁，另一半作为奖池。'
                },
                raid: {
                    title: '星际掠夺',
                    desc: '策略类游戏。升级飞船、购买燃料均需消耗代币，这些消耗将永久移除市场流通量。'
                }
            },
            games: {
                title: '游戏矩阵',
                subtitle: '每一款游戏都被设计为烧毁加速器',
                guess: {
                    status: '已上线',
                    title: '量子猜数',
                    desc: '预测获胜号码，每一次失误都会被送入虚空。',
                    btn: '进入游戏'
                },
                dice: {
                    title: '熵之轮盘',
                    desc: '高频风险振荡器。这是一场与智能合约的俄罗斯轮盘赌。极简的规则，极致的暴力美学——输家即刻灰飞烟灭，赢家带走一切。',
                    status: '接入中'
                },
                crash: {
                    title: '最后幸存者',
                    desc: '大逃杀入场费按 1:1 分配为销毁和奖池。',
                    status: '设计中'
                },
                lottery: {
                    title: '黑暗森林掠夺',
                    desc: '零和博弈战场。在这个资源匮乏的宇宙中，隐藏自己，做好清理。利用燃料升级你的坐标系，向对手发起降维打击，掠夺他们的流动性。',
                    status: '设计中'
                }
            },
            features: {
                title: '协议信条',
                fair: {
                    title: '可验证与审计',
                    desc: '透明合约，链上销毁地址与审计记录公开可查。'
                },
                burn: {
                    title: '销毁优先',
                    desc: '没有通胀阀门，每次交互都把价值导向虚空。'
                },
                instant: {
                    title: '即时结算',
                    desc: '基于 BNB Chain 的低延迟体验与快速终局性。'
                },
                community: {
                    title: '社区引力',
                    desc: '建设者接入事件视界，激励与稀缺性保持同向。'
                }
            },
            faq: {
                title: '常见问答 · 事件视界',
                q1: '如何确保销毁数据真实？',
                a1: '只展示链上证明，待预言机连通后实时更新，不展示伪造占位数字。',
                q2: '为何选择 BNB Chain？',
                a2: '低费用与高流动性支持高频交互，同时保持良好的玩家体验。',
                q3: '游戏如何加入矩阵？',
                a3: '工作室通过事件视界 SDK 接入，并遵循交互即销毁的经济模型。',
                q4: '为什么代码是法律？',
                a4: '在 B.A.P，我们不相信人性，我们只相信数学。合约的所有权已丢弃（Renounced），流动性已锁死（Locked）。黑洞没有后门，数学没有偏见。',
                q5: '所谓的“公平”如何定义？',
                a5: '基于链上 VRF (可验证随机函数) 的绝对随机。上帝不摔骰子，但我们的智能合约会。每一个结果都可追溯、可验证、不可篡改。'
            },
            cta: {
                title: '跨越事件视界',
                desc: '没有通胀，只有湮灭的艺术。',
                btn: '连接界面'
            },
            entropy: {
                section_title: '熵减的艺术',
                module1: {
                    tag: '熵问题',
                    title: '宇宙热寂',
                    content: '宇宙趋向于最大熵——无序、混沌、热寂。在传统加密经济中，通胀是原罪。无限制的代币增发稀释价值，就像膨胀的宇宙冷却至绝对零度。\n\n每一个新代币都是向经济热寂迈进的一步。终局不可避免：毫无价值的资产散落在冰冷、死寂的区块链上。',
                    keywords: ['热寂', '通胀', '熵', '稀释价值']
                },
                module2: {
                    tag: '黑洞解决方案',
                    title: 'B.A.P. 机制',
                    content: 'BNB 湮灭协议是一个逆向奇点——一个不可逆地吞噬代币的黑洞。每一次游戏交互都会触发永久销毁。代币跨越事件视界，消失在地址 0x00...dead 中。\n\n这不是通缩。这是湮灭。我们不减少供应——我们将其从存在中抹除。协议是一个单向膜：进入、燃烧、永不返回。',
                    keywords: ['黑洞', '不可逆', '湮灭', '事件视界', '单向']
                },
                module3: {
                    tag: '价值奇点',
                    title: '稀缺性捕获',
                    content: '随着总供应量向零坍缩，剩余代币压缩成价值奇点。稀缺性不是制造出来的——它是数学强制执行的。每次销毁都会增加对剩余价值的引力。\n\n赢家不仅仅是赚取奖励——他们从收缩的宇宙中捕获浓缩价值。这是金融炼金术：将丰富转化为稀缺，将混沌转化为秩序。',
                    keywords: ['奇点', '稀缺性', '数学强制', '浓缩价值', '炼金术']
                }
            }
        },
        game: {
            title: '熵之轮盘',
            subtitle: '多轮 · Token Burn · 公平随机',
            connect_wallet: '连接 MetaMask',
            admin_mode: '管理员模式',
            owner_mode: '所有者模式',
            game_mode: '游戏模式',
            game_mode_desc: '选择轮次',
            connecting_contract: '连接智能合约',
            setup_contract: '设置合约地址',
            default_contract: '默认合约已配置',
            use_this: '使用此地址',
            or_input: '或输入其他合约地址...',
            set_contract_btn: '设置合约',
            loading: '处理中，请稍候...',
            owner_console: '所有者控制台',
            owner_desc: '仅限合约部署者访问 · 创建和管理轮次',
            fuel_token_addr: '燃料代币地址',
            quick_select: '快速选择:',
            burn_amount: '销毁数量',
            ticket_price: '入场费 (BNB)',
            duration: '持续时间 (小时)',
            start_round: '开始新轮次',
            active_rounds: '活跃轮次',
            no_active_rounds: '当前没有活跃轮次',
            round: '轮次',
            pot: '奖池',
            participants: '玩家',
            time_left: '剩余时间',
            ended: '结束',
            join: '加入游戏',
            settle: '结算轮次',
            my_number: '我的数字',
            max_number: '最大数字',
            status: {
                active: '进行中',
                settled: '已结算'
            },
            steps: {
                approve: '步骤 1/2: 授权代币中...',
                join: '步骤 2/2: 加入游戏中...'
            },
            errors: {
                install_metamask: '请安装MetaMask',
                connect_failed: '连接失败',
                setup_failed: '设置失败',
                invalid_addr: '无效地址',
                already_joined: '您已加入此轮次'
            },
            success: {
                connected: '钱包连接成功!',
                contract_set: '合约连接成功!',
                round_started: '新轮次开始!',
                joined: '成功加入!',
                settled: '轮次结算! 奖励发放'
            },
            hall: {
                title: '游戏大厅',
                desc: '选择轮次开始投注',
                total_rounds: '总轮次',
                active: '进行中',
                no_games: '没有进行中的游戏',
                admin_hint: '在管理员控制台开始新轮次'
            },
            auto_connected: '自动连接到合约成功!',
            cleanup: {
                button: '清理过期轮次',
                processing: '清理过期轮次...',
                success_count: '成功清理 {count} 过期轮次!',
                success_none: '没有找到过期轮次',
                error: '清理失败: {error}'
            },
            card: {
                prize_pool: '奖池',
                players: '玩家',
                time_left: '剩余时间',
                ticket: '门票',
                burn: '销毁',
                tokens: '代币',
                enter_game: '进入游戏',
                burning: '销毁中',
                winner: '赢家',
                claim: '领取奖励',
                settle: '结算轮次',
                full: '已满员',
                expired: '已过期',
                joined: '加入成功',
                your_number: '你的号码',
                status: {
                    run: '进行中',
                    end: '已结束',
                    waiting: '等待结算',
                    active: '状态'
                }
            },
            rules: {
                title: '游戏机制',
                subtitle: '系统蓝图与协议',
                dual_token: {
                    title: '双代币系统',
                    fuel: '燃料代币',
                    fuel_desc: '100% 销毁至黑洞',
                    settlement: '结算代币',
                    settlement_desc: 'BNB 用于奖励'
                },
                allocation: {
                    title: '资金分配',
                    winner: '赢家奖池',
                    reserve: '下轮储备',
                    dev: '开发成本'
                },
                cycle: {
                    title: '游戏周期',
                    step1: '开启轮次',
                    step1_desc: '管理员设置代币和时长',
                    step2: '加入翻牌',
                    step2_desc: '支付 BNB + 燃料 → 随机数字',
                    step3: '结算触发',
                    step3_desc: '20 名玩家 或 时间到期',
                    step4: '结算分配',
                    step4_desc: '最高数字获胜',
                    condition_a: '条件 A',
                    condition_b: '条件 B',
                    or: '或'
                }
            }
        }
    }
};
